import React from 'react';
import { Route, IndexRedirect } from 'react-router';

// FBT
import FbtDriver from '../driver/FbtDriver';
import FbtDriverVehicle from '../driver/FbtDriverVehicle';
import FbtExemption from '../driver/FbtExemption';

import { lazyLoadComponent } from '../../../routes/routeUtils';

// Routes
import * as routes from './const';

const fbtReducer = { name: 'fbt', import: () => import('../reducer') };

const Fbtroutes = store => (
  <Route path={routes.FBT}>
    <IndexRedirect to={routes.FBT_DRIVER} />
    <Route
      path={routes.FBT_DRIVER}
      getComponent={lazyLoadComponent(FbtDriver, store, fbtReducer)}
    />
    <Route
      path={routes.FBT_VEHICLE}
      getComponent={lazyLoadComponent(FbtDriverVehicle, store, fbtReducer)}
    />
    <Route
      path={routes.FBT_EXEMPTION}
      getComponent={lazyLoadComponent(FbtExemption, store, fbtReducer)}
    />
  </Route>
);

export default Fbtroutes;



// WEBPACK FOOTER //
// ./src/features/fbt/routes/index.js